/*
 * PDP quantity - main selector <-> sticky bar sync, and GoKwik "Buy It Now" in metres
 * -----------------------------------------------------------------------------------
 * Added 2026-09-24.
 *
 * PART 1 - ONE QUANTITY ON THE PAGE
 *   The product page has two quantity inputs: the main one (linked to the main
 *   product form) and the one in the sticky add-to-cart bar (linked to the sticky
 *   form). Nothing copied the value between them, so setting 3 m in the main
 *   selector left the sticky bar on 1 m, and vice versa. This keeps them equal.
 *
 *   The pair is found through <hdt-sticky-btn-atc form="...">, whose form
 *   attribute holds the MAIN product form id (see tradeuno-sticky-atc-always.js).
 *   Values are copied without firing events, so no other script reacts twice.
 *
 * PART 2 - GOKWIK BUY IT NOW SENDS QUARTER-METRE UNITS
 *   Fabric is stocked in 0.25 m units, so "3 Meters" must reach Shopify as 12.
 *   tradeuno-fabric-meter.js converts on submit and on clicks of
 *   [type="submit"] / [name="add"]. The GoKwik button is type="button" with an
 *   inline onclick, so it was never converted: 3 m went to checkout as 3 units
 *   (0.75 m) - the "3 items, Rs 270.75" seen at checkout.
 *
 *   On a Buy It Now click (window, capture phase - before GoKwik's onclick), a
 *   hidden name="quantity" input carrying the converted unit count is placed
 *   just before the visible input, and the visible input's name is removed for a
 *   few seconds. Whatever GoKwik reads - FormData(form), form.elements or
 *   document.querySelector('[name="quantity"]') - it finds the correct units,
 *   while the shopper still sees metres. Everything is put back after
 *   HOLD_MS, or immediately when the shopper touches the quantity control or an
 *   add-to-cart button.
 *
 *   Only applies to products on the "decimal" template
 *   (data-tradeuno-fabric-chunks-per-meter="4"). Other products are untouched.
 *
 * TO REVERT: delete the <script> tag for this file from layout/theme.liquid.
 */
(function () {
  if (window.__tuPdpQtySync) return;
  window.__tuPdpQtySync = true;

  var CHUNK = 0.25;
  var HOLD_MS = 6000;
  var EPS = 1e-9;

  /* ---- shared helpers --------------------------------------------------- */

  function cssEscape(s) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
    return String(s).replace(/["\\]/g, '\\$&');
  }

  function pdpPair() {
    var sticky = document.querySelector('hdt-sticky-btn-atc');
    if (!sticky) return null;
    var mainFormId = sticky.getAttribute('form');
    if (!mainFormId) return null;
    var stickyInp = sticky.querySelector('input.hdt-quantity__input');
    var mainInp = document.querySelector('input.hdt-quantity__input[form="' + cssEscape(mainFormId) + '"]');
    if (!stickyInp || !mainInp || stickyInp === mainInp) return null;
    return { main: mainInp, sticky: stickyInp };
  }

  function refreshButtons(inp) {
    var wrap = inp.closest('[data-tradeuno-fabric-qty], hdt-quantity-wrapp');
    if (!wrap) return;
    var min = parseFloat(inp.getAttribute('min'));
    if (isNaN(min)) min = 1;
    var max = parseFloat(inp.getAttribute('max'));
    var v = parseFloat(inp.value);
    if (isNaN(v)) v = min;
    var minus = wrap.querySelector('.is--minus');
    var plus = wrap.querySelector('.is--plus');
    if (minus) minus.classList.toggle('disabled', v <= min + EPS);
    if (plus) plus.classList.toggle('disabled', !isNaN(max) && v >= max - EPS);
  }

  /* ---- Part 1: keep main + sticky equal --------------------------------- */

  function syncFrom(src) {
    var p = pdpPair();
    if (!p) return;
    var dst = src === p.main ? p.sticky : src === p.sticky ? p.main : null;
    if (!dst) return;
    // Mid add-to-cart, fabric-meter.js briefly writes unit counts into the input.
    if (src.dataset.tradeunoConverting === '1' || dst.dataset.tradeunoConverting === '1') return;
    if (src.value === '' || dst.value === src.value) {
      refreshButtons(dst);
      return;
    }
    dst.value = src.value;
    refreshButtons(dst);
  }

  ['input', 'change', 'focusout'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var inp = e.target;
      if (!(inp instanceof HTMLInputElement) || !inp.classList.contains('hdt-quantity__input')) return;
      if (swap && inp === swap.visible) restore();
      // Let fabric-meter.js round/clamp first, then copy the final value.
      window.setTimeout(function () {
        syncFrom(inp);
      }, 0);
    });
  });

  // +/- buttons change the value without firing events.
  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('[data-tradeuno-fabric-step], .hdt-quantity__button') : null;
    if (!btn) return;
    var wrap = btn.closest('[data-tradeuno-fabric-qty], hdt-quantity-wrapp');
    var inp = wrap && wrap.querySelector('input.hdt-quantity__input');
    if (!inp) return;
    window.setTimeout(function () {
      syncFrom(inp);
    }, 30);
  });

  /* ---- Part 2: GoKwik Buy It Now in quarter-metre units ----------------- */

  var swap = null; // { visible, hidden, name, timer }

  function restore() {
    if (!swap) return;
    window.clearTimeout(swap.timer);
    if (swap.hidden.parentNode) swap.hidden.parentNode.removeChild(swap.hidden);
    swap.visible.setAttribute('name', swap.name);
    swap = null;
  }

  function fabricForm(btn) {
    var form = btn.form || btn.closest('form');
    if (!form) return null;
    var holder = form.closest('[data-tradeuno-fabric-chunks-per-meter]');
    var raw =
      (holder && holder.getAttribute('data-tradeuno-fabric-chunks-per-meter')) ||
      (form.dataset && form.dataset.tradeunoFabricChunksPerMeter) ||
      '1';
    return parseInt(raw, 10) >= 4 ? form : null;
  }

  // The quantity input sits outside the <form> and is linked by its form
  // attribute, so it is reached through form.elements.
  function meterInput(form) {
    var els = Array.prototype.slice.call(form.elements || []);
    for (var i = 0; i < els.length; i++) {
      var inp = els[i];
      if (!(inp instanceof HTMLInputElement)) continue;
      if (inp.dataset.tradeunoMeterQty !== 'true') continue;
      if (inp.name === 'updates[]') continue;
      return inp;
    }
    return null;
  }

  window.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;

      var buy = t.closest('#gokwik-buy-now');
      if (!buy) {
        if (swap && t.closest('[data-tradeuno-fabric-qty], hdt-quantity-wrapp, [type="submit"], [name="add"]')) {
          restore();
        }
        return;
      }
      if (buy.disabled) return;

      var form = fabricForm(buy);
      if (!form) return;

      var visible = swap ? swap.visible : meterInput(form);
      if (!visible) return;

      var minChunks = parseInt(visible.dataset.tradeunoMinChunks || '1', 10);
      var meters = parseFloat(visible.value);
      if (isNaN(meters)) meters = minChunks * CHUNK;
      var chunks = Math.max(minChunks, Math.round(meters / CHUNK));

      if (!swap) {
        var name = visible.getAttribute('name') || 'quantity';
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        if (form.id) hidden.setAttribute('form', form.id);
        hidden.setAttribute('data-tradeuno-buynow-qty', 'true');
        visible.parentNode.insertBefore(hidden, visible);
        visible.removeAttribute('name');
        swap = { visible: visible, hidden: hidden, name: name, timer: null };
      }

      swap.hidden.value = String(chunks);

      // Covers a synchronous read of the visible input itself (e.g. by class):
      // units for the duration of this click only, metres again on the next tick.
      var shownMeters = visible.value;
      visible.value = String(chunks);
      window.setTimeout(function () {
        visible.value = shownMeters;
      }, 0);

      window.clearTimeout(swap.timer);
      swap.timer = window.setTimeout(restore, HOLD_MS);
    },
    true
  );

  document.addEventListener('shopify:section:load', restore);
})();
